<script setup lang="ts">
  import { TabsTrigger } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  defineProps<{
    value: string
    disabled?: boolean
    class?: HTMLAttributes['class']
  }>()
</script>

<template>
  <TabsTrigger
    :value="value"
    :disabled="disabled"
    :class="
      cn(
        'text-muted-foreground inline-flex items-center gap-1.5 px-3 pb-2.5 pt-1 text-sm font-medium transition-colors',
        'hover:text-foreground',
        'data-[state=active]:text-primary',
        'disabled:pointer-events-none disabled:opacity-50',
        '[&_svg:not([class*=size-])]:size-4 [&_svg]:shrink-0',
        $props.class
      )
    "
  >
    <slot />
  </TabsTrigger>
</template>
